import { buildRadarData } from '../../player/PlayerOverview/PlayerRadar.Tile.helpers';

export const createTeamSlice = (set) => ({
  // --- State ---
  teamOverviewRadarOffenseData: [],
  teamOverviewRadarDefenseData: [],
  // --- Actions ---
  setTeamOverviewRadarOffenseData: (
    radarOffenseData,
    offenseTemplate,
    radarOffenseComparisonData,
  ) => {
    const data = buildRadarData(
      radarOffenseData,
      offenseTemplate,
      radarOffenseComparisonData,
    );
    set({ teamOverviewRadarOffenseData: data });
  },
  setTeamOverviewRadarDefenseData: (
    radarDefenseData,
    defenseTemplate,
    radarDefenseComparisonData,
  ) => {
    const data = buildRadarData(
      radarDefenseData,
      defenseTemplate,
      radarDefenseComparisonData,
    );
    set({ teamOverviewRadarDefenseData: data });
  },
});
